import { useState } from "react";
import { Link } from "react-router-dom";
import InputField from "../../components/inputField/inputField";
import PrimaryBtn from "../../components/primaryButton/primaryBtn";
import AuthLayout from "../../components/authLayout/authLayout";

const SignUp = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const getUserEmail = (event) => {
    console.log(event.target.value);
  };
  const getUserPassword = (event) => {
    console.log(event.target.value);
  };
  const getUserName = (event) => {
    console.log(event.target.value);
  };
  const onSubmit = () => {};
  const renderItem = () => {
    return (
      <form className="authentication-form">
        <img className="logo" src="/assets/images/logo.png" alt="" />
        <h2>Create your account</h2>
        <div className="form-group">
          <label className="form-label">Name</label>
          <InputField type="name" changeEvent={getUserName} />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <InputField type="email" changeEvent={getUserEmail} />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <div className="selected-input">
            <InputField type={showPassword ? "text" : "password"} changeEvent={getUserPassword} />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className={showPassword ? "ri-eye-line" : "ri-eye-off-line"}></button>
          </div>
        </div>
        {/* <div className="mb-3">
          <div className="form-check">
            <input type="checkbox" className="form-check-input" id="checkbox-signin" />
            <label className="form-check-label" for="checkbox-signin">
              I accept Terms and Condition
            </label>
          </div>
        </div> */}

        <div className="mb-1 text-center d-grid">
          <PrimaryBtn type="submit" submitBtn={onSubmit}>
            Create Account
          </PrimaryBtn>
          <p className="small">
            Already have an account? <Link to="/signin">Sign In</Link>
          </p>
        </div>
      </form>
    );
  };

  return <AuthLayout renderItem={renderItem} />;
};

export default SignUp;
